<card *routerOuter [name]="'Account ' + (initial || id)">
  <div card controls>
    <tabs-route [items]="routes"></tabs-route>
  </div>

  <div card content>
    <router-outlet></router-outlet>
  </div>
</card>
